import { render, staticRenderFns } from "./OrganismButtonsRow.vue?vue&type=template&id=7fd2cace&scoped=true"
import script from "./OrganismButtonsRow.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganismButtonsRow.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd2cace",
  null
  
)

export default component.exports